<agpr-checkbox
    id="preserveEditCheckbox"
    class="agpr-bulk-action-form-renormalize-checkbox"
    name="preserveEdit"
    label="Monitoring.bulk.action.renormalize.preserveEdit"
    tooltip="Monitoring.bulk.action.renormalize.preserveEditTooltip"
    [binary]="true"
    [value]="preserveEdit"
    [(ngModel)]="preserveEdit"
    (ngModelChange)="changed()"
>
</agpr-checkbox>